import React from 'react';
import { cn } from '../../utils/cn';

export interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/** Left-aligned empty/error state: icon, what happened, what to do next. */
export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, children, action, className }) => (
  <div className={cn('flex flex-col items-start gap-3 py-8 text-left', className)}>
    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sunken text-muted" aria-hidden="true">
      {icon}
    </span>
    <div>
      <p className="text-base font-semibold text-ink">{title}</p>
      {children && <div className="mt-1 text-sm text-muted">{children}</div>}
    </div>
    {action && <div className="mt-1">{action}</div>}
  </div>
);
